import { createSelector } from 'reselect'

import { removeHTMLTags } from 'util/strings'

import {
  selectCurrentTicket,
  selectCurrentTicketId,
} from 'selectors/tickets/current'

export const selectUndecoratedTicketReplyDrafts = state =>
  state.drafts.replies || {}

const selectRawReplyDraft = createSelector(
  selectCurrentTicketId,
  selectUndecoratedTicketReplyDrafts,
  (ticketId, drafts) => drafts[ticketId]
)

export const selectHasReplyDraft = createSelector(
  selectRawReplyDraft,
  draft => draft && draft.body && removeHTMLTags(draft.body)
)

export const selectHasToChangedInReplyDraft = createSelector(
  selectCurrentTicket,
  selectRawReplyDraft,
  (ticket, draft) => {
    return (
      draft &&
      draft.to &&
      draft.to[0] &&
      ticket &&
      ticket.customer &&
      draft.to[0].id !== ticket.customer.id
    )
  }
)

export const selectHasCcChangedInReplyDraft = createSelector(
  selectRawReplyDraft,
  draft => draft && draft.cc && draft.cc.length > 0
)

export const selectHasBccChangedInReplyDraft = createSelector(
  selectRawReplyDraft,
  draft => draft && draft.bcc && draft.bcc.length > 0
)

export const selectHasFromChangedInReplyDraft = createSelector(
  selectCurrentTicket,
  selectRawReplyDraft,
  (ticket, draft) =>
    draft && ticket && draft.mailboxId && draft.mailboxId !== ticket.mailboxId
)

export const selectHasSubjectChangedInReplyDraft = createSelector(
  selectCurrentTicket,
  selectRawReplyDraft,
  (ticket, draft) =>
    draft && ticket && draft.title && draft.title !== ticket.title
)
